import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

const HeaderBar = () =>{
    const emp:any = useSelector((state: any) => state.emp);   
    let navigate = useNavigate();

    const navega = (url: string) =>{
      navigate(`${url}`);
    }

    console.log("Entorno: ", emp);

    return (
        <nav className="navbar bg-body-tertiary">
            <div className="container-fluid">
                <div className="d-flex justify-content-center m-3">
                    <img  className="img-fluid" alt="Bienvenido a Coosalud"  src="https://coosalud-dev.outsystemsenterprise.com/Login/img/Login_CW.logo_coosalud.png?cj4Zp4YmT0_Mybz+AyalDg"/>
                </div>
                <div className="d-flex align-items-center gap-2 text-success" role="search">
                    <div>
                        <span className="badge "><i className="bi bi-bell-fill h5 text-success"></i></span>                        
                    </div>
                    <div>
                        <span className="badge "><i className="bi bi-person-circle h1 fw-b text-success"></i></span>
                    </div>
                    <div>
                        <label htmlFor="" className="text-center">{emp.user}</label>
                    </div>
                    <div className="btn btn-outline-success" onClick={()=>navega('/')}>
                        <i className="bi bi-power h5 fw-b"></i>
                    </div>                    
                </div>
            </div>
        </nav>
    );
};

export default HeaderBar;